import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const cloneViaSigEditor = {
  element: '#studio > div.page-content > div.container-fluid > div > div:nth-child(1) > div',
  popover: {
    title: $format('label.TOURS.STUDIO.CLONE.CLONE_SIG_EDITOR.TITLE'),
    description: $format('label.TOURS.STUDIO.CLONE.CLONE_SIG_EDITOR.DESCRIPTION'),
    side: 'right',
    align: 'center',
    onPrevClick: () => {
      const actionsButton = document.querySelector('.os-icon-more-horizontal');
      const cloneToDomain = document.querySelector('[data-testid="sig-action-clone-domain"]');

      if (actionsButton) {
        actionsButton.click();
      }

      if (cloneToDomain) {
        cloneToDomain.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 160);
      } else {
        GLOBAL_DRIVER_OBJECT.moveTo(2);
      }
    },
    onNextClick: () => {
      const sigCard = document.querySelector(
        '#studio > div.page-content > div.container-fluid > div > div:nth-child(1) > div'
      );

      if (sigCard) {
        sigCard.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 200);
      }
    }
  }
};
